// Select all elements with the class 'swatch_button Size-button'
const buttons = document.querySelectorAll("input.swatch_button.Size-button");
var inventoryThreshold = parseInt(
    window.PXUTheme.theme_settings.inventory_threshold
);
const product_count_one = window.PXUTheme.translation.product_count_other;
const product = JSON.parse(
    document.querySelector(".product_form").dataset["product"]
);
const variantInventoryString = document.querySelector(".product_form").dataset["variantInventory"];
const qty = JSON.parse(variantInventoryString.replace(/"inventory_quantity":,/g, '"inventory_quantity":0,'));
const url = new URL(window.location.href);
const variantValue = url.searchParams.get("variant");
const selectedVariant = product.variants.find((item) => item.id == window.TriplePixelData.product.variant);
// Building our mapping object. For Size Avaliable and soldout Update
optionsMap = {};

for (var i = 0; i < product.variants.length; i++) {
    var variant = product.variants[i];

    if (variant.available) {
        // Gathering values for the 1st drop-down.
        optionsMap["root"] = optionsMap["root"] || [];
        optionsMap["root"].push(variant.option1);
        optionsMap["root"] = Shopify.uniq(optionsMap["root"]); // Gathering values for the 2nd drop-down.

        if (product.options.length > 1) {
            var key2 = variant.option1;
            optionsMap[key2] = optionsMap[key2] || [];
            optionsMap[key2].push(variant.option2);
            optionsMap[key2] = Shopify.uniq(optionsMap[key2]);
        } // Gathering values for the 3rd drop-down.

        if (product.options.length === 3) {
            var key2 = variant.option1 + " / " + variant.option2;
            optionsMap[key2] = optionsMap[key2] || [];
            optionsMap[key2].push(variant.option3);
            optionsMap[key2] = Shopify.uniq(optionsMap[key2]);
        }
    }
}
const parent = ".product-" + product.id + " .js-product_section";
var key3 = null;
var key4 = null;
const parentElement = document.querySelector(".select-container"); // Replace `parent` with your actual parent selector

const observer2 = new MutationObserver(function (mutationsList, observer) {
    key3 = $(parent + " .single-option-selector:eq(0)").val();
    key4 = $(parent + " .single-option-selector:eq(1)").val();

    function updateSwatchElements(key, optionIndex) {
        if (key) {
            var availableOptions = optionsMap[optionIndex == 1 ? key3 : (key3 + ' / ' + key4)];
            var sizeChecked = false;
            $(parent + ' .swatch[data-option-index="' + optionIndex + '"] .swatch-element').each(
                function () {
                    if ($.inArray($(this).attr("data-value"), availableOptions) !== -1) {
                        $(this)
                            .removeClass("soldout")
                            .find(":radio")
                            .removeAttr("disabled", "disabled")
                            .removeAttr("checked");
                        if (!sizeChecked) {
                            this.previousElementSibling.checked = true;
                            sizeChecked = true;
                            // URL
                            var urlTemp = new URL(window.location.href);
                            const newVariantId = this.previousElementSibling.dataset['availableVariant'];
                            urlTemp.searchParams.set("variant", newVariantId);
                            window.history.replaceState({}, "", urlTemp);
                        }
                        if (selectedVariant.options[optionIndex] === this.dataset.value) {
                            this.previousElementSibling.checked = true;
                            // URL
                            var urlTemp = new URL(window.location.href);
                            urlTemp.searchParams.set("variant", window.TriplePixelData.product.variant);
                            window.history.replaceState({}, "", urlTemp);
                        }
                    } else {
                        $(this)
                            .addClass("soldout")
                            .find(":radio")
                            .removeAttr("checked")
                            .attr("disabled", "disabled");
                        this.previousElementSibling.checked = false;
                    }
                }
            );
        }
    }

    updateSwatchElements(key3, 1);
    updateSwatchElements(key4, 2);

    // Update SKU only once after all swatches are updated
    // setTimeout(() => {
    //     const variantId = new URL(window.location.href).searchParams.get("variant");
    //     if (variantId) {
    //         const currentVariant = product.variants.find(v => 
    //             v.id.toString() === variantId && 
    //             v.available
    //         );
    //         if (currentVariant) {
    //             document.getElementsByClassName("sku")[0].innerHTML = currentVariant.sku;
    //         }
    //     }
    // }, 100);

    if (key3 || key4) {
        observer2.disconnect();
    }
});


observer2.observe(parentElement, { childList: true, subtree: true });

// Function to handle the event
function handleButtonChange(event) {
    var option1 = $('.product_form form').find('.swatch_options input:checked').eq(0).val();
    var option2 = $('.product_form form').find('.swatch_options input:checked').eq(1).val() || '';
    var option3 = $('.product_form form').find('.swatch_options input:checked').eq(2).val() || '';

    if (option1 && option2 && option3) {
        var notifyMessage = option1 + ' / ' + option2 + ' / ' + option3;
    } else if (option1 && option2) {
        var notifyMessage = option1 + ' / ' + option2;
    } else {
        var notifyMessage = option1;
    }
    var variant = null;
    if (option3 != '') {
        variant = product.variants.find((item) => item.title.includes(option1 + ' / ' + option2) && item.available);
        variant = product.variants.find((item) => item.title.includes(notifyMessage) && item.available) != undefined ? product.variants.find((item) => item.title.includes(notifyMessage) && item.available) : variant;
    } else {
        variant = JSON.parse(event.target.dataset["variant"]);
    }
    // Check if the button is checked
    if (event.target.checked) {
        //Uncheck the sold out size
        if (event.target.name[event.target.name.length - 1] === '1') {
            if (!optionsMap[variant.options[0]].includes(event.target.ariaLabel)) {
                var temp_variant = product.variants.find((item) => item.id.toString() === new URL(window.location.href).searchParams.get("variant"));
                document.getElementById('swatch-1-' + temp_variant.options[1].toLowerCase() + '-' + product.id).checked = true;
                return;
            }
        }
        if (event.target.name[event.target.name.length - 1] === '2') {
            if (!optionsMap[variant.options[0] + ' / ' + variant.options[1]].includes(event.target.ariaLabel)) {
                var temp_variant = product.variants.find((item) => item.id.toString() === new URL(window.location.href).searchParams.get("variant"));
                document.getElementById('swatch-2-' + temp_variant.options[2].toLowerCase() + '-' + product.id).checked = true;
                return;
            }
        }

        var inventory_quantity = qty.find(
            (item) => item.id === variant.id
        ).inventory_quantity;
        var sku = variant.sku;

        // console.log("Button checked:", variant);
        if (inventory_quantity <= inventoryThreshold) {
            document.getElementsByClassName("items_left")[0].innerHTML =
                inventory_quantity + " " + product_count_one;
        } else {
            document.getElementsByClassName("items_left")[0].innerHTML = " ";
        }

        // SKU
        // document.getElementsByClassName("sku")[0].innerHTML = sku;
        const currentVariant = product.variants.find((item) => item.id == window.TriplePixelData.product.variant);
        if (variant && variant.available) {
              document.getElementsByClassName("sku")[0].innerHTML = variant.sku;
        }

        // URL
        const url = new URL(window.location.href);
        if (variant.id) url.searchParams.set("variant", variant.id);
        window.history.replaceState({}, "", url);

        // current price
        if (variant.price > 0) {
            document.getElementsByClassName("current_price")[0].innerHTML =
                '<span class="money">' +
                Shopify.formatMoney(variant.price, $("body").data("money-format")) +
                "</span>";
        } else {
            document.getElementsByClassName("current_price")[0].innerHTML =
                window.PXUTheme.translation.free_price_text;
        }

        // Saving price
        if (variant && variant.available == true) {
            if (variant.price < variant.compare_at_price) {
                document.getElementsByClassName("was-price")[0].innerHTML =
                    '<span class="money">' +
                    Shopify.formatMoney(
                        variant.compare_at_price,
                        $("body").data("money-format")
                    ) +
                    "</span>";
                document.getElementsByClassName("savings")[0].innerHTML =
                    window.PXUTheme.translation.savings +
                    " " +
                    parseInt(
                        ((variant.compare_at_price - variant.price) * 100) /
                        variant.compare_at_price
                    ) +
                    "% (" +
                    '<span class="money">' +
                    Shopify.formatMoney(
                        variant.compare_at_price - variant.price,
                        $("body").data("money-format")
                    ) +
                    "</span>)";
                document
                    .getElementsByClassName("current_price")[0]
                    .parentElement.classList.add("sale");
                var discount_value =
                    ((variant.compare_at_price - variant.price) * 100) /
                    variant.compare_at_price;
                if (discount_value >= 40) {
                    document.getElementsByClassName("clearance-message")[0].innerHTML =
                        '<span><b style="color: #892f24;">FINAL CLEARANCE:</b> Final Clearance styles cannot be exchanged or returned. Valid while supplies last. All sales final.</span>';
                } else {
                    document.getElementsByClassName("clearance-message")[0].innerHTML =
                        "";
                }
            } else {
                document.getElementsByClassName("was-price")[0].innerHTML = "";
                document.getElementsByClassName("savings")[0].innerHTML = "";
                document
                    .getElementsByClassName("current_price")[0]
                    .parentElement.classList.remove("sale");
                document.getElementsByClassName("clearance-message")[0].innerHTML = "";
            }
        }

        // Addd to cart update
        document
            .getElementById("product-select-" + product.id)
            .children.forEach(function (item) {
                if (item.value == variant.id.toString()) item.selected = true;
            });

        // Update quantity box
        document.querySelector(".has-quantity-box .quantity-input").max = inventory_quantity;
    } else {
        // console.log("Button unchecked:", variant);
        // Add your custom logic here
    }
}

// Add event listeners to each button
buttons.forEach((button) => {
    button.addEventListener("change", handleButtonChange);
});
// Product "E-Gift Certificate" ID:6561880670415
if (product.id == 6561880670415) {
    if (variantValue != null) {
        buttons.forEach((item, index) => {
            if (variantValue == meta.product.variants[index].id) {
                item.checked = true;
            }
        });
    } else {
        document.querySelectorAll(
            "input.swatch_button.Size-button"
        )[0].checked = true;
    }
}
$('body').on('change', '.swatch :radio.option_index-1', function () {
    var optionIndex = $(this).closest('.swatch').attr('data-option-index');
    if (optionIndex == "1") {
        var parentForm = $(this).closest('.product_form form');

        if (parentForm.siblings('.notify_form').length) {
            var notifyForm = parentForm.siblings('.notify_form');
        } else {
            var notifyForm = $('.js-notify-form');
        }

        var option1 = parentForm.find('.swatch_options input:checked').eq(0).val();
        var option2 = parentForm.find('.swatch_options input:checked').eq(1).val() || '';
        var option3 = parentForm.find('.swatch_options input:checked').eq(2).val() || '';

        if (option1 && option2 && option3) {
            var notifyMessage = option1 + ' / ' + option2 + ' / ' + option3;
        } else if (option1 && option2) {
            var notifyMessage = option1 + ' / ' + option2;
        } else {
            var notifyMessage = option1;
        }

        notifyForm.find(".notify_form_message").attr("value", notifyForm.find(".notify_form_message").data('body') + " - " + notifyMessage);
        updateOptionsInSelector(2, parent, option2);

        if (option3) {
            var availableOptions = optionsMap[2 == 1 ? option1 : (option1 + ' / ' + option2)];
            var sizeChecked = false;
            var variant = null;
            variant = product.variants.find((item) => item.title.includes(option1 + ' / ' + option2) && item.available);
            variant = product.variants.find((item) => item.title.includes(notifyMessage) && item.available) != undefined ? product.variants.find((item) => item.title.includes(notifyMessage) && item.available) : variant;
            $(parent + ' .swatch[data-option-index="' + 2 + '"] .swatch-element').each(
                function () {
                    if ($.inArray($(this).attr("data-value"), availableOptions) !== -1) {
                        $(this)
                            .removeClass("soldout")
                            .find(":radio")
                            .removeAttr("disabled", "disabled")
                            .removeAttr("checked");

                        if ($(this).attr("data-value") === variant.option3) {
                            this.previousElementSibling.checked = true;
                            sizeChecked = true;
                        }
                    } else {
                        $(this)
                            .addClass("soldout")
                            .find(":radio")
                            .removeAttr("checked")
                            .attr("disabled", "disabled");
                        this.previousElementSibling.checked = false;
                    }
                }
            );
        }
    }
}); //Swatches linked with selected options

updateOptionsInSelector = function (selectorIndex, parent, option2) {
    switch (selectorIndex) {
        case 0:
            var key = 'root';
            break;

        case 1:
            var key = $(parent + ' .single-option-selector:eq(0)').val();
            break;

        case 2:
            var key = $(parent + ' .single-option-selector:eq(0)').val() + ' / ' + option2;
        // key += ' / ' + $(parent + ' .single-option-selector:eq(1)').val();
    }

    var availableOptions = optionsMap[key];
    $(parent + ' .swatch[data-option-index="' + selectorIndex + '"] .swatch-element').each(function () {
        if ($.inArray($(this).attr('data-value'), availableOptions) !== -1) {
            $(this).removeClass('soldout').find(':radio').removeAttr('disabled', 'disabled').removeAttr('checked');
        } else {
            $(this).addClass('soldout').find(':radio').removeAttr('checked').attr('disabled', 'disabled');
        }
    });
};